var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.536,
    height: 24.546,
    viewBox: "0 0 24.536 24.546",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-logout-5413097-566D93",
    transform: "translate(-74.405 -64.054)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M388.56,308.5a1.69,1.69,0,1,0-2.319,2.46l2.083,1.965h-9.878a1.69,1.69,0,0,0,0,3.379h9.878l-2.083,1.969a1.69,1.69,0,0,0,2.321,2.458l5.18-4.89a1.693,1.693,0,0,0,0-2.456Z",
    transform: "translate(-295.328 -238.284)",
    fill: "#58585a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M85.415,85.221h-7.63V67.433h7.63a1.689,1.689,0,1,0,0-3.379H76.1a1.692,1.692,0,0,0-1.69,1.69V86.91A1.692,1.692,0,0,0,76.1,88.6h9.32a1.689,1.689,0,0,0,0-3.379Z",
    fill: "#58585a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.766cbaa2b88d5f60222047a75b53b3bb.svg";
export { ForwardRef as ReactComponent };